<template>
  <NavigationBar />
  <router-view></router-view>
  <FooterComponent />
</template>

<script>
import { onBeforeMount } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { auth } from "@/firebase/firebaseInit";
import NavigationBar from './components/layout/NavigationBar.vue';
import FooterComponent from './components/layout/FooterComponent.vue';

export default {
  name: 'App',
  components: {
    NavigationBar,
    FooterComponent
  },

  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    onBeforeMount(() => {
      auth.onAuthStateChanged(async (user) => {
        if (!user) {
          const requiresAuth = route.matched.some(r => r.meta?.requiresAuth);
          if (requiresAuth) {
            router.replace('/volunteer');
          }
        } else if (route.path == "/login") {
          await store.dispatch('user/loadUserProfile');
          const isAdmin = store.getters['user/isCurrentUserAdmin'];
          router.replace(isAdmin ? '/' : '/volunteer');
        }
      });
    })
  }
}
</script>

<style>
@import 'bulma/css/bulma.min.css';

.main {
  text-align: left;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5rem;
  margin: 0 auto;
}

.align-center {
  text-align: center;
}

tr.green {
  background-color: #c7e9c0;
}

.modal-card-foot {
    justify-content: center;
}

.page-container {
  min-height: calc(100vh - 60px); /* Adjust 60px if your footer height is different */
  padding-bottom: 100px; /* This is the crucial part: add padding equal to footer height */
  box-sizing: border-box; /* Important: Include padding in element's total height */
  /* Or use flexbox: display: flex; flex-direction: column; min-height: 100vh; */
}

.sticky-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff; /* Or any background color */
  padding: 10px;
  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow */
  z-index: 100; /* Ensure it's above other content */
  /* Add other styling as needed (e.g., text alignment, button styles) */
  display: flex; /* Or block, depending on your button layout */
  justify-content: center; /* Center the button horizontally */
}
</style>
